import { createReportData } from "../../models/reportData.model";

export const accountingReportState = {
  reportData: createReportData(),
}